module.exports = "/assets/data/79e4244779d3c52db231ae65123783b9-CF45.data.json";